import React, { useEffect } from 'react';
import { Stack, IStackTokens, StackItem, PrimaryButton, SpinButton, Position } from '@fluentui/react';
import strings from '../../../loc/strings';
import { PeriodsListItem } from '../../../model/PeriodsListItem';
import { fetchPeriods } from "../../../services/AdminServices/PeriodsService";
import { useAuth } from "react-oidc-context";
import styles from './Periods.module.css';
import { UpdatePeriods } from "../../../services/AdminServices/PeriodsService";
import { displayMessageBar } from '../../LayoutWithAuth/LayoutWithAuth';
import { MessageBarType } from "@fluentui/react";

const stackToken2: IStackTokens = { childrenGap: 20, padding: "0 10px 10px 0" };

interface Iperiods {
    AnswerPeriod: string;
    EscalationPeriod: string;
    RecycleBinPeriod: string;
    RetentionPeriod: string;
}

const editableKeys: string[] = ["AnswerPeriod", "EscalationPeriod", "RecycleBinPeriod", "RetentionPeriod"];

function Periods() {
    const auth = useAuth();
    const [items, setItems] = React.useState<PeriodsListItem[]>([]);
    const [periods, setPeriods] = React.useState<Iperiods>({
        AnswerPeriod: "0",
        EscalationPeriod: "0",
        RecycleBinPeriod: "0",
        RetentionPeriod: "0",
    });


    const updatePeriodsI = (periods: any) => {
        let message;
        let messageBarType;

        UpdatePeriods(periods, auth.user?.id_token).then((response: any) => {

            if (response.length == editableKeys.length) {
                message = "The Periods page has been updated successfully.";
                messageBarType = MessageBarType.success;
                displayMessageBar(messageBarType, message, false);
            } else {

                message = "Error on update Periods.";
                messageBarType = MessageBarType.error;
                displayMessageBar(messageBarType, message, false);
            }
        })
            .catch((error: any) => {
                message = "Error on update Periods.";
                messageBarType = MessageBarType.error;
                displayMessageBar(messageBarType, message, false);
                console.error(`Error updating Periods: ${error.message}`);
            });

    };


    const fetchDataAndSetItems = async () => {
        try {
            const result = await fetchPeriods("1", auth.user?.id_token);
            setItems(result);

            result.forEach((item) => {
                const key = item.key as keyof Iperiods;
                setPeriods((prevPeriods) => ({ ...prevPeriods, [key]: item.value }));
            });
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };
    interface PeriodChangeParams {
        period: string;
        event: React.SyntheticEvent<HTMLElement>;
        newValue?: any;
    }


    useEffect(() => {
        fetchDataAndSetItems();
    }, []);

    /** Remove the suffix or any other text after the numbers, or return undefined if not a number */
    const getNumericPart = (value: string): number | undefined => {
        const positiveIntegerRegex = /^(\d+)$/;

        if (positiveIntegerRegex.test(value)) {
            const numericValue = Number(value.replace(positiveIntegerRegex, '$1'));
            return Number.isNaN(numericValue) ? undefined : numericValue;
        }
        return undefined;
    };

    const onValidate = (value: string, event?: React.SyntheticEvent<HTMLElement>): string | void => {

        const min = 0;
        let numericValue = getNumericPart(value);
        if (numericValue !== undefined) {
            numericValue = Math.max(numericValue, min);
            return String(numericValue);
        }


    }

    const onChangePeriods = React.useCallback(({ period, event, newValue }: PeriodChangeParams) => {

        if (newValue !== undefined) {

            setPeriods((prevPeriods) => ({ ...prevPeriods, [period]: newValue }));

        }
    }, []);



    const handlesave = () => {

        const updatedItems = items
            .filter(item => editableKeys.includes(item.key))
            .map(item => {
                const key = item.key as keyof Iperiods;
                return { key, value: periods[key] };
            });


        setItems(updatedItems);
        updatePeriodsI(updatedItems);

    }

    const disabledButtonStyles = {
        root: {
            backgroundColor: '#EDEDED',
            borderColor: '#EDEDED',
            color: '#A0A0A0',
            //cursor: 'not-allowed', 
        },
        rootHovered: {
            backgroundColor: '#EDEDED',
            borderColor: '#EDEDED',
            color: '#A0A0A0',
        },
    };

    return (
        <Stack>
            <StackItem className={styles.periodscontainer}>
                <h2 className={styles.periodsHeader}>Periods</h2>
                <div className={styles.periodsfields}>
                    <Stack horizontal tokens={stackToken2}>

                        <SpinButton min={0} downArrowButtonStyles={periods.AnswerPeriod === "0" ? disabledButtonStyles : undefined} labelPosition={Position.top} label={strings.PeriodsAnswer} value={periods.AnswerPeriod} className='AnswerPeriod' onChange={(event, newValue) => onChangePeriods({ period: 'AnswerPeriod', event, newValue })} onValidate={onValidate} />
                        <SpinButton min={0} downArrowButtonStyles={periods.EscalationPeriod === "0" ? disabledButtonStyles : undefined} labelPosition={Position.top} label={strings.PeriodsEscalation} value={periods.EscalationPeriod} className='EscalationPeriod' onChange={(event, newValue) => onChangePeriods({ period: 'EscalationPeriod', event, newValue })} onValidate={onValidate} />
                        <SpinButton min={0} downArrowButtonStyles={periods.RetentionPeriod === "0" ? disabledButtonStyles : undefined} labelPosition={Position.top} label={strings.PeriodsRetention} value={periods.RetentionPeriod} className='RetentionPeriod' onChange={(event, newValue) => onChangePeriods({ period: 'RetentionPeriod', event, newValue })} onValidate={onValidate} />
                        <SpinButton min={0} downArrowButtonStyles={periods.RecycleBinPeriod === "0" ? disabledButtonStyles : undefined} labelPosition={Position.top} label={strings.PeriodsRecycle} value={periods.RecycleBinPeriod} className='RecycleBinPeriod' onChange={(event, newValue) => onChangePeriods({ period: 'RecycleBinPeriod', event, newValue })} onValidate={onValidate} />

                    </Stack>


                </div>
                <div className={styles.periodsbtn}>
                    <PrimaryButton text={strings.ButtonSave} onClick={handlesave} />
                </div>
            </StackItem>

        </Stack>
    );
}



export default Periods;
